import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import LoadingDashboardValue from '../loadingDashboardValue/LoadingDashboardValue';

const mapStateToProps = (state: RootState) => ({
    isLoading: state.api.draw_down_repayment_schedule.pending
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LoadingDashboardValue);
